<ng-container *ngIf="lessons">
    <mat-accordion>
        <mat-expansion-panel *ngFor="let lesson of lessons; index as i;"
        (opened)="DefaultValue(i, lesson)"
        >
            <mat-expansion-panel-header>
                <mat-panel-title>
                {{lesson.name}}
                <a [routerLink]="['/admin/course', course_id, 'lesson', lesson.id]" href="">Перейти</a>
                </mat-panel-title>
                
                <mat-panel-description *ngIf="openedIndex == i">
                    {{status}}
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="openedIndex == i">
                <form action="" [formGroup]="LessonForm">
                    <mat-form-field class="full-width">
                        <mat-label>Название урока</mat-label>
                        <input formControlName="name" matInput name="name" placeholder="Ex. Учимся Select" value="{{lesson.name}}">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Теория</mat-label>
                        <textarea formControlName="theory" rows="12" matInput name="theory" placeholder="Ex. Чтобы делать select надо...">{{lesson.theory}}</textarea>
                    </mat-form-field>
                    <button (click)="editLesson(lesson.id,i)" mat-raised-button>Save</button>
                    <button (click)="deleteLesson(lesson.id,i)" mat-raised-button color="warn">Delete</button>
                </form>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel (opened)="LessonForm.reset();">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <button mat-mini-fab color="primary" aria-label="Example icon button with a home icon">
                        <mat-icon>add</mat-icon>
                    </button>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <form action="" [formGroup]="LessonForm">
                <mat-form-field class="full-width">
                    <mat-label>Название урока</mat-label>
                    <input formControlName="name" matInput name="name" placeholder="Ex. Учимся Select">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Теория</mat-label>
                    <textarea formControlName="theory" rows="12" matInput name="theory" placeholder="Ex. Чтобы делать select надо..."></textarea>
                </mat-form-field>
                <button (click)="addLesson()" mat-raised-button>Add</button>
            </form>
        </mat-expansion-panel>
      </mat-accordion>      
</ng-container>
